import * as Sentry from '@sentry/react';

// In map workflows, missing site equipment stats are expected and can return a 404.
export function ignoreSiteEquipmentStats404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorReponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/sites\/(\w|-){36}\/stats$/;
  const isFetchingSiteEquipmentStats = regexp.test(requestUrl);

  return is404ErrorReponse && isGETRequest && isFetchingSiteEquipmentStats;
}
